import React, { useState } from 'react';
import {
  Box,
  Modal,
  Typography,
  IconButton,
  Button,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Alert,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import RefreshIcon from '@mui/icons-material/Refresh';

const TransactionPinModal = ({ open, handleClose }) => {
  const theme = useTheme();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <Modal open={open} onClose={handleClose}>
  <Box
  sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 3,
    width: '100%',
    maxWidth: 'calc(100% - 20px)',
    minWidth: 300,
    boxSizing: 'border-box',
    mx: 'auto',
  }}
>
        {/* Close Icon */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Title */}
        <Typography variant="h6" fontWeight="bold" mb={3}>
          Change Transaction PIN
        </Typography>

        {/* New PIN Field */}
        <FormControl fullWidth sx={{ mb: 3 }}>
          <OutlinedInput
            type="password"
            placeholder="Enter new transaction PIN"
            startAdornment={
              <InputAdornment position="start">
                <VpnKeyIcon color="disabled" />
              </InputAdornment>
            }
          />
          <Typography variant="caption" sx={{ mt: 1 }}>
            Create a secure PIN that you can remember
          </Typography>
        </FormControl>

        {/* Current Password Field */}
        <FormControl fullWidth sx={{ mb: 3 }}>
          <OutlinedInput
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter your current password"
            startAdornment={
              <InputAdornment position="start">
                <LockIcon color="disabled" />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={togglePasswordVisibility} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <Typography variant="caption" sx={{ mt: 1 }}>
            For security verification
          </Typography>
        </FormControl>

        {/* Security Alert */}
        <Alert severity="warning" sx={{ mb: 3, fontSize: '0.85rem' }}>
          <strong>Security Alert</strong><br />
          Keep your transaction PIN confidential. Never share your PIN with anyone, including bank representatives.
        </Alert>

        {/* Submit Button */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={() => console.log('Update Transaction PIN')}
        >
          Update Transaction PIN
        </Button>
      </Box>
    </Modal>
  );
};

export default TransactionPinModal;